import type { ReactNode } from 'react';
import squiggle from '../../design/assets/text-accent-squiggle.svg';
import squiggleShort from '../../design/assets/text-accent-squiggle-sm.svg';

/**
 * Port of the DS `TextAccent`: the hand-drawn squiggle under emphasised words
 * — the brand's emphasis device, in place of underline or bold.
 */
const COLOR = {
  orange: 'var(--hp-orange)',
  green: 'var(--hp-green)',
  blue: 'var(--hp-blue)',
  gold: 'var(--hp-olive)',
  cream: 'var(--hp-cream)',
  brown: 'var(--hp-brown-deep)',
} as const;

export function TextAccent({
  children,
  color = 'orange',
  short = false,
}: {
  children: ReactNode;
  color?: keyof typeof COLOR;
  short?: boolean;
}) {
  const mask = `url('${short ? squiggleShort : squiggle}')`;
  return (
    <span className="relative inline-block whitespace-nowrap">
      {children}
      <span
        aria-hidden="true"
        className="absolute bottom-[-0.32em] left-[-2%] right-[-2%] h-[0.42em]"
        style={{
          backgroundColor: COLOR[color],
          WebkitMaskImage: mask,
          maskImage: mask,
          WebkitMaskRepeat: 'no-repeat',
          maskRepeat: 'no-repeat',
          WebkitMaskSize: '100% 100%',
          maskSize: '100% 100%',
        }}
      />
    </span>
  );
}
